import { Hero } from '../components/Hero';
import { InfoCard } from '../components/InfoCard';
import { FaqItem } from '../components/FaqItem';
import { Link } from '../components/Link';
import { Reveal } from '../components/Reveal';

const ways = [
  {
    title: 'Koken',
    description:
      'We beginnen ons programma met het team met een lunch. Zou je een keer een lunch willen voorbereiden? Laat het ons weten.',
    imageSrc:
      'https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1600&q=80',
  },
  {
    title: 'Koffie schenken',
    description:
      'Naast het veld wordt er door vrijwilligers koffie en thee aangeboden aan ouders. Als je dit een keer wilt doen, neem dan contact met ons op.',
    imageSrc:
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1600&q=80',
  },
  {
    title: 'Financieel ondersteunen',
    description:
      'Wij hebben wekelijkse kosten voor de lunch, ranja en chocolaatjes op het veld. Daarnaast kopen wij kleding voor nieuwe teamleden. Neem contact op voor meer informatie over een financiële gift.',
    imageSrc:
      'https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?auto=format&fit=crop&w=1600&q=80',
  },
];

export const DraagBij = () => {
  return (
    <>
      <Hero
        title="Bouw je mee?"
        description="Onze sportcommunity draait op vrijwilligers en is afhankelijk van giften. Er zijn verschillende manieren waarop jij mee kan helpen."
        imageSrc="/images/hero-tenboer.jpg"
        fullHeight
        overlay
        eyebrow="Draag bij"
      />

      {/* Intro pull-quote */}
      <section className="py-24 md:py-28 px-6 sm:px-10 md:px-16 bg-[#0D0A00] relative overflow-hidden">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
            <div className="md:col-span-3">
              <span className="eyebrow text-white/55">Visie</span>
            </div>
            <div className="md:col-span-9">
              <p className="font-serif-display italic text-[26px] md:text-[34px] text-white leading-[1.3] max-w-[28ch]">
                "Wij bouwen samen mee aan het Koninkrijk van God. Daarin zijn we afhankelijk van Hem en vertrouwen we dat God voorziet in wat nodig is — we geloven ook dat Hij werkt door mensen heen."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Manieren om te helpen */}
      <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-[#FBFAF6]">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20 md:mb-28">
            <div className="md:col-span-5">
              <span className="eyebrow text-[#0D0A00]/60">Meehelpen</span>
            </div>
            <div className="md:col-span-7">
              <h2 className="text-[#0D0A00] text-[40px] md:text-[56px] font-medium tracking-[-0.035em] leading-[1.02]">
                Waarmee kan je{' '}
                <span className="font-serif-display italic font-normal text-[#0D0A00]/70">ons helpen?</span>
              </h2>
            </div>
          </div>

          <div className="flex flex-col gap-24 md:gap-32">
            {ways.map((item, i) => (
              <Reveal key={item.title}>
                <InfoCard {...item} index={i} reverse={i % 2 === 1} />
              </Reveal>
            ))}
          </div>

          <div className="mt-20 flex justify-start">
            <Link
              href="/contact"
              className="btn-pill"
              style={{ background: '#0D0A00', color: '#fff' }}
            >
              Neem contact op
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-28 md:py-36 px-6 sm:px-10 md:px-16 bg-[#0D0A00] relative overflow-hidden">
        <div
          className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full opacity-[0.08] blur-3xl pointer-events-none"
          style={{ background: '#F5B800' }}
        />
        <div className="container mx-auto max-w-6xl relative">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
            <div className="lg:col-span-5">
              <span className="eyebrow text-white/55">Veelgestelde vragen</span>
              <h2 className="mt-6 text-white text-[40px] md:text-[52px] font-medium tracking-[-0.03em] leading-[1.03]">
                Vragen?{' '}
                <span className="font-serif-display italic font-normal text-[#F5B800]">Wij denken mee.</span>
              </h2>
              <a
                href="/contact"
                className="btn-pill mt-10"
                style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' }}
              >
                Neem contact op
                <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
            <div className="lg:col-span-7 flex flex-col">
              <FaqItem
                question="Wat moet mijn kind meenemen naar Restart?"
                answer="In principe niks. Wij hebben voetballen bij ons en zorgen voor drinken en wat lekkers."
              />
              <FaqItem
                question="Wat zijn de kosten?"
                answer="Meedoen is gratis. Er zijn geen verplichtingen bij Restart. We verwachten natuurlijk wel dat er geluisterd wordt naar onze teamleden."
              />
              <FaqItem
                question="Hoe houdt Restart contact met de ouders?"
                answer="We houden ouders op de hoogte via Instagram en de nieuwsbrief. Het leukste vinden we om jullie te ontmoeten bij het veld."
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
